function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var PrepareStoreTemplate = require('./prepare-store.template');
var _require = require('../../categories'),
  isSellableNftType = _require.isSellableNftType,
  isVaultRentalNftType = _require.isVaultRentalNftType;
var PREPARE_MS = 1300;
var STATUS_MS = 250;
var POLL_MS = 3500;
var STATUS_MESSAGES = ['Checking store URL', 'Verifying public key', 'Preparing your store', 'Checking availability', 'Finalizing store configuration'];
var PrepareStoreOverlay = /*#__PURE__*/function () {
  function PrepareStoreOverlay(app, mod) {
    _classCallCheck(this, PrepareStoreOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.defaults = {};
    this.has_nfts = false;
    this.has_tokens = false;
    this.wizard_state = 1;
    this.wizard_key = '';
    this.awaiting_mint_tx = '';
    this.status_timer = null;
    this.poll_timer = null;
    this.prepare_token = 0;
    this.faucet_option = null;
    this.upload_action = null;
    this.onContinue = null;
    this.onCreateNft = null;
  }
  return _createClass(PrepareStoreOverlay, [{
    key: "render",
    value: function render() {
      var _this = this;
      var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.defaults = defaults || {};
      this.has_nfts = false;
      this.has_tokens = false;
      this.wizard_state = 1;
      this.wizard_key = '';
      this.awaiting_mint_tx = '';
      this.faucet_option = null;
      this.upload_action = null;
      this.stopPreparation();
      this.stopPolling();
      this.overlay.show(PrepareStoreTemplate.overlay(), function () {
        _this.stopPreparation();
        _this.stopPolling();
      });
      this.startPreparation();
    }
  }, {
    key: "stopPreparation",
    value: function stopPreparation() {
      this.prepare_token += 1;
      if (this.status_timer) {
        clearInterval(this.status_timer);
        this.status_timer = null;
      }
    }
  }, {
    key: "stopPolling",
    value: function stopPolling() {
      if (this.poll_timer) {
        clearInterval(this.poll_timer);
        this.poll_timer = null;
      }
    }
  }, {
    key: "startPreparation",
    value: function startPreparation() {
      var _this2 = this;
      var token = ++this.prepare_token;
      var index = 0;
      this.setStatus(STATUS_MESSAGES[0]);
      this.status_timer = setInterval(function () {
        if (token !== _this2.prepare_token) {
          return;
        }
        index += 1;
        if (index < STATUS_MESSAGES.length) {
          _this2.setStatus(STATUS_MESSAGES[index]);
        }
      }, STATUS_MS);
      Promise.all([this.refreshWalletState(), this.publishStorefrontLink(), this.wait(PREPARE_MS)]).then(function () {
        if (token !== _this2.prepare_token) {
          return;
        }
        _this2.showReady();
      })["catch"](function (err) {
        console.warn('Store: prepare overlay failed', (err === null || err === void 0 ? void 0 : err.message) || err);
        if (token !== _this2.prepare_token) {
          return;
        }
        _this2.showReady();
      });
    }
  }, {
    key: "wait",
    value: function wait() {
      var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return new Promise(function (resolve) {
        return setTimeout(resolve, Math.max(0, ms));
      });
    }
  }, {
    key: "setStatus",
    value: function setStatus() {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var el = document.querySelector('.prepare-store [data-prepare-status]');
      if (!el) {
        return;
      }
      el.classList.add('is-exit');
      setTimeout(function () {
        el.textContent = text;
        el.classList.remove('is-exit');
      }, 120);
    }
  }, {
    key: "deriveWizardState",
    value: function deriveWizardState() {
      if (this.has_nfts) {
        return 3;
      }
      if (this.has_tokens || this.awaiting_mint_tx) {
        return 2;
      }
      return 1;
    }
  }, {
    key: "applyMonotonicStage",
    value: function applyMonotonicStage() {
      var derived = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var next = Number(derived) || 1;
      this.wizard_state = Math.max(this.wizard_state, next);
    }
  }, {
    key: "refreshWalletState",
    value: function () {
      var _refreshWalletState = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return Promise.all([this.loadWalletNfts(), this.loadWalletTokens()]);
            case 1:
              this.applyMonotonicStage(this.deriveWizardState());
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function refreshWalletState() {
        return _refreshWalletState.apply(this, arguments);
      }
      return refreshWalletState;
    }()
    /**
     * Wallet NFT list — same source the NFT picker uses.
     */
  }, {
    key: "loadWalletNfts",
    value: function () {
      var _loadWalletNfts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this$app$wallet,
          _this$app$options,
          _this3 = this;
        var nft_list;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(typeof ((_this$app$wallet = this.app.wallet) === null || _this$app$wallet === void 0 ? void 0 : _this$app$wallet.updateNFTList) === 'function')) {
                _context2.n = 1;
                break;
              }
              _context2.n = 1;
              return this.app.wallet.updateNFTList();
            case 1:
              nft_list = ((_this$app$options = this.app.options) === null || _this$app$options === void 0 || (_this$app$options = _this$app$options.wallet) === null || _this$app$options === void 0 ? void 0 : _this$app$options.nfts) || [];
              this.has_nfts = nft_list.some(function (rec) {
                var nft_type = '';
                try {
                  var _rec$slip;
                  nft_type = _this3.app.wallet.extractNFTType((rec === null || rec === void 0 || (_rec$slip = rec.slip3) === null || _rec$slip === void 0 ? void 0 : _rec$slip.utxo_key) || '') || '';
                } catch (err) {
                  nft_type = '';
                }
                return isSellableNftType(nft_type) || isVaultRentalNftType(nft_type);
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function loadWalletNfts() {
        return _loadWalletNfts.apply(this, arguments);
      }
      return loadWalletNfts;
    }()
  }, {
    key: "loadWalletTokens",
    value: function () {
      var _loadWalletTokens = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$app$wallet2, balance, has_available, has_pending, crypto, pending, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return this.app.wallet.getBalance();
            case 1:
              balance = _context3.v;
              has_available = typeof balance === 'bigint' ? balance > 0n : Number(balance) > 0;
              has_pending = false;
              crypto = (_this$app$wallet2 = this.app.wallet) === null || _this$app$wallet2 === void 0 ? void 0 : _this$app$wallet2.saitoCrypto;
              if (!(crypto && typeof crypto.getPendingBalance === 'function')) {
                _context3.n = 3;
                break;
              }
              _context3.n = 2;
              return crypto.getPendingBalance();
            case 2:
              pending = _context3.v;
              has_pending = typeof pending === 'bigint' ? pending > 0n : Number(pending) > 0;
            case 3:
              this.has_tokens = has_available || has_pending || !!this.awaiting_mint_tx;
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t = _context3.v;
              this.has_tokens = !!this.awaiting_mint_tx;
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 4]]);
      }));
      function loadWalletTokens() {
        return _loadWalletTokens.apply(this, arguments);
      }
      return loadWalletTokens;
    }()
    /**
     * Existing store-creation side effect: publish the storefront URL to Profile.
     */
  }, {
    key: "publishStorefrontLink",
    value: function () {
      var _publishStorefrontLink = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this$mod$returnStore, _this$mod, _this$mod$returnProfi, _this$mod2;
        var url;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(!this.mod.publicKey || typeof this.mod.updateProfile !== 'function')) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              url = (_this$mod$returnStore = (_this$mod = this.mod).returnStorefrontUrl) === null || _this$mod$returnStore === void 0 ? void 0 : _this$mod$returnStore.call(_this$mod, this.mod.publicKey);
              if (url) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2);
            case 2:
              if (!(((_this$mod$returnProfi = (_this$mod2 = this.mod).returnProfileStoreUrl) === null || _this$mod$returnProfi === void 0 ? void 0 : _this$mod$returnProfi.call(_this$mod2)) === url)) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2);
            case 3:
              _context4.n = 4;
              return this.mod.updateProfile(url);
            case 4:
              this.app.connection.emit('store-profile-link-updated');
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function publishStorefrontLink() {
        return _publishStorefrontLink.apply(this, arguments);
      }
      return publishStorefrontLink;
    }()
  }, {
    key: "showReady",
    value: function showReady() {
      var _this4 = this;
      this.stopPreparation();
      var root = document.querySelector('.prepare-store');
      var title = document.querySelector('.prepare-store [data-prepare-title]');
      var lede = document.querySelector('.prepare-store [data-prepare-lede]');
      var preparing = document.querySelector('.prepare-store .preparing-panel');
      var ready = document.querySelector('.prepare-store .ready-panel');
      if (!root || !ready) {
        return;
      }
      if (title) {
        title.textContent = 'Your Store is Ready!';
      }
      if (lede) {
        lede.hidden = false;
      }
      this.app.connection.emit('store-profile-link-updated');
      this.renderReadyPanel();
      preparing === null || preparing === void 0 || preparing.classList.add('is-exit');
      window.setTimeout(function () {
        if (!document.querySelector('.prepare-store')) {
          return;
        }
        if (preparing) {
          preparing.hidden = true;
          preparing.classList.remove('is-exit');
        }
        ready.hidden = false;
        root.classList.remove('preparing');
        root.classList.add('ready');
        _this4.startPolling();
      }, 180);
    }
  }, {
    key: "renderReadyPanel",
    value: function renderReadyPanel() {
      var _this$mod$returnStore2, _this$mod3;
      var ready = document.querySelector('.prepare-store .ready-panel');
      if (!ready) {
        return;
      }
      var actions = this.returnAvailableActions();
      var store_url = ((_this$mod$returnStore2 = (_this$mod3 = this.mod).returnStorefrontUrl) === null || _this$mod$returnStore2 === void 0 ? void 0 : _this$mod$returnStore2.call(_this$mod3, this.mod.publicKey)) || '';
      var key = this.returnViewKey(this.wizard_state, actions, store_url);
      if (key === this.wizard_key && ready.innerHTML.trim()) {
        return;
      }
      this.wizard_key = key;
      ready.innerHTML = PrepareStoreTemplate.ready({
        state: this.wizard_state,
        actions: actions,
        store_url: store_url,
        awaiting_mint: !!this.awaiting_mint_tx
      });
      this.attachReadyEvents();
    }
  }, {
    key: "returnViewKey",
    value: function returnViewKey(state) {
      var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var store_url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      return [state, this.awaiting_mint_tx ? 1 : 0, actions.get_saito ? 1 : 0, actions.faucet ? 1 : 0, actions.create_nft ? 1 : 0, actions.upload_media ? 1 : 0, actions.list_item ? 1 : 0, actions.visit_admin ? 1 : 0, store_url].join('|');
    }

    /**
     * Discover optional actions through respondTo / existing connection events.
     * Missing modules simply omit their action.
     */
  }, {
    key: "returnAvailableActions",
    value: function returnAvailableActions() {
      var _this$app$connection, _this$app$modules$get, _this$app$modules, _this$app$connection2, _this$app$modules$ret, _this$app$modules2, _vault$access_file_ov, _this$mod$main;
      var actions = {
        get_saito: false,
        faucet: false,
        create_nft: false,
        upload_media: false,
        list_item: false,
        visit_admin: false
      };
      this.faucet_option = null;
      this.upload_action = null;
      if (typeof ((_this$app$connection = this.app.connection) === null || _this$app$connection === void 0 ? void 0 : _this$app$connection.listenerCount) === 'function' && this.app.connection.listenerCount('saito-purchase-launch') > 0) {
        actions.get_saito = true;
      }
      var faucet = (((_this$app$modules$get = (_this$app$modules = this.app.modules).getRespondTos) === null || _this$app$modules$get === void 0 ? void 0 : _this$app$modules$get.call(_this$app$modules, 'buysaito-options')) || []).find(function (item) {
        return (item === null || item === void 0 ? void 0 : item.available) && typeof item.beginProviderAuth === 'function';
      });
      if (faucet) {
        this.faucet_option = faucet;
        actions.faucet = true;
      }
      if (typeof this.onCreateNft === 'function' || typeof ((_this$app$connection2 = this.app.connection) === null || _this$app$connection2 === void 0 ? void 0 : _this$app$connection2.listenerCount) === 'function' && this.app.connection.listenerCount('saito-nft-create-render-request') > 0) {
        actions.create_nft = true;
      }
      var vault = (_this$app$modules$ret = (_this$app$modules2 = this.app.modules).returnModule) === null || _this$app$modules$ret === void 0 ? void 0 : _this$app$modules$ret.call(_this$app$modules2, 'Vault');
      var file_upload = vault === null || vault === void 0 || (_vault$access_file_ov = vault.access_file_overlay) === null || _vault$access_file_ov === void 0 ? void 0 : _vault$access_file_ov.file_upload_overlay;
      if (file_upload && typeof file_upload.render === 'function') {
        this.upload_action = {
          callback: function callback() {
            var _vault$attachStyleShe;
            (_vault$attachStyleShe = vault.attachStyleSheets) === null || _vault$attachStyleShe === void 0 || _vault$attachStyleShe.call(vault);
            file_upload.render();
          }
        };
        actions.upload_media = true;
      }
      if (typeof this.onContinue === 'function') {
        actions.list_item = true;
      }
      if (typeof ((_this$mod$main = this.mod.main) === null || _this$mod$main === void 0 ? void 0 : _this$mod$main.openStorefront) === 'function' || typeof this.mod.returnAdminPath === 'function') {
        actions.visit_admin = true;
      }
      return actions;
    }
  }, {
    key: "startPolling",
    value: function startPolling() {
      var _this5 = this;
      this.stopPolling();
      if (this.wizard_state === 3) {
        return;
      }
      this.poll_timer = setInterval(function () {
        void _this5.pollWalletState();
      }, POLL_MS);
    }
  }, {
    key: "pollWalletState",
    value: function () {
      var _pollWalletState = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this$mod$transaction;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (document.querySelector('.prepare-store.ready')) {
                _context5.n = 1;
                break;
              }
              this.stopPolling();
              return _context5.a(2);
            case 1:
              if (!(this.awaiting_mint_tx && (_this$mod$transaction = this.mod.transaction_monitor) !== null && _this$mod$transaction !== void 0 && _this$mod$transaction.tx)) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2);
            case 2:
              _context5.n = 3;
              return this.refreshWalletState();
            case 3:
              if (document.querySelector('.prepare-store.ready')) {
                _context5.n = 4;
                break;
              }
              this.stopPolling();
              return _context5.a(2);
            case 4:
              this.renderReadyPanel();
              if (this.wizard_state === 3) {
                this.stopPolling();
              }
            case 5:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function pollWalletState() {
        return _pollWalletState.apply(this, arguments);
      }
      return pollWalletState;
    }()
  }, {
    key: "attachReadyEvents",
    value: function attachReadyEvents() {
      var _this6 = this;
      var root = document.querySelector('.prepare-store');
      if (!root) {
        return;
      }
      var bind = function bind(action, handler) {
        root.querySelectorAll("[data-action=\"".concat(action, "\"]")).forEach(function (el) {
          el.onclick = function (e) {
            e.preventDefault();
            handler();
          };
          if (el.tagName === 'A' || el.getAttribute('role') === 'button') {
            el.onkeydown = function (e) {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handler();
              }
            };
          }
        });
      };
      bind('get-saito', function () {
        return _this6.openGetSaito();
      });
      bind('faucet', function () {
        return _this6.openFaucet();
      });
      bind('create-nft', function () {
        return _this6.openCreateNft();
      });
      bind('upload-media', function () {
        return _this6.openUploadMedia();
      });
      bind('list-item', function () {
        return _this6.openListItem();
      });
      bind('visit-admin', function () {
        return _this6.openStoreAdmin();
      });
      bind('copy-url', function () {
        return _this6.copyStoreUrl();
      });
    }
  }, {
    key: "openGetSaito",
    value: function openGetSaito() {
      this.app.connection.emit('saito-purchase-launch');
    }
  }, {
    key: "openFaucet",
    value: function openFaucet() {
      var _faucet$providers;
      var faucet = this.faucet_option;
      if (!faucet || typeof faucet.beginProviderAuth !== 'function') {
        return;
      }
      var provider = ((_faucet$providers = faucet.providers) === null || _faucet$providers === void 0 || (_faucet$providers = _faucet$providers[0]) === null || _faucet$providers === void 0 ? void 0 : _faucet$providers.id) || 'free_use';
      faucet.beginProviderAuth(provider);
    }
  }, {
    key: "openCreateNft",
    value: function openCreateNft() {
      var _this7 = this;
      var defaults = _objectSpread(_objectSpread({}, this.defaults || {}), {}, {
        callback: function callback(result) {
          return _this7.onNftCreateResult(result);
        }
      });
      if (typeof this.onCreateNft === 'function') {
        this.onCreateNft(defaults);
        return;
      }
      this.app.connection.emit('saito-nft-create-render-request', defaults);
    }
  }, {
    key: "onNftCreateResult",
    value: function onNftCreateResult() {
      var _result$tx;
      var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if ((result === null || result === void 0 ? void 0 : result.status) === 'cancelled') {
        return;
      }
      if ((result === null || result === void 0 ? void 0 : result.status) !== 'created' || !(result !== null && result !== void 0 && result.tx)) {
        return;
      }
      var signature = String(result.signature || ((_result$tx = result.tx) === null || _result$tx === void 0 ? void 0 : _result$tx.signature) || '').trim();
      this.awaiting_mint_tx = signature;
      this.applyMonotonicStage(2);
      if (document.querySelector('.prepare-store.ready')) {
        this.renderReadyPanel();
      }
      this.watchMintTransaction(result.tx);
    }
  }, {
    key: "watchMintTransaction",
    value: function watchMintTransaction(tx) {
      var _this8 = this;
      if (!(tx !== null && tx !== void 0 && tx.signature)) {
        return;
      }
      if (!this.mod.transaction_monitor) {
        console.error('Store: transaction_monitor is not initialized');
        return;
      }
      this.stopPolling();
      this.mod.transaction_monitor.render({
        tx: tx,
        title: 'Creating NFT',
        lead: 'Your NFT is being broadcast to the Saito network.',
        subtitle: 'Waiting for confirmation...',
        successTitle: 'NFT Created',
        successLead: 'Your NFT is confirmed and ready to list on your store.',
        successActionLabel: 'Continue',
        callback: function callback(result) {
          if ((result === null || result === void 0 ? void 0 : result.status) === 'confirmed') {
            void _this8.onMintConfirmed();
            return;
          }
          if ((result === null || result === void 0 ? void 0 : result.status) === 'cancelled') {
            _this8.awaiting_mint_tx = '';
            if (document.querySelector('.prepare-store.ready')) {
              _this8.renderReadyPanel();
              _this8.startPolling();
            }
          }
        }
      });
    }
  }, {
    key: "onMintConfirmed",
    value: function () {
      var _onMintConfirmed = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              this.awaiting_mint_tx = '';
              _context6.n = 1;
              return this.refreshWalletState();
            case 1:
              if (document.querySelector('.prepare-store.ready')) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2);
            case 2:
              this.renderReadyPanel();
              if (!(this.wizard_state === 3)) {
                _context6.n = 3;
                break;
              }
              this.stopPolling();
              return _context6.a(2);
            case 3:
              this.startPolling();
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function onMintConfirmed() {
        return _onMintConfirmed.apply(this, arguments);
      }
      return onMintConfirmed;
    }()
  }, {
    key: "openUploadMedia",
    value: function openUploadMedia() {
      var _this$upload_action;
      if (typeof ((_this$upload_action = this.upload_action) === null || _this$upload_action === void 0 ? void 0 : _this$upload_action.callback) === 'function') {
        this.upload_action.callback(this.app, this.mod);
      }
    }
  }, {
    key: "openListItem",
    value: function openListItem() {
      this.overlay.close();
      if (typeof this.onContinue === 'function') {
        this.onContinue(this.defaults);
      }
    }
  }, {
    key: "openStoreAdmin",
    value: function openStoreAdmin() {
      var _this$mod$main2, _this$mod$returnAdmin, _this$mod4;
      this.overlay.close();
      if (typeof ((_this$mod$main2 = this.mod.main) === null || _this$mod$main2 === void 0 ? void 0 : _this$mod$main2.openStorefront) === 'function' && this.mod.publicKey) {
        void this.mod.main.openStorefront(this.mod.publicKey, {
          admin: true
        });
        return;
      }
      var path = (_this$mod$returnAdmin = (_this$mod4 = this.mod).returnAdminPath) === null || _this$mod$returnAdmin === void 0 ? void 0 : _this$mod$returnAdmin.call(_this$mod4, this.mod.publicKey);
      if (path && typeof navigateWindow === 'function') {
        navigateWindow(path);
      }
    }
  }, {
    key: "copyStoreUrl",
    value: function () {
      var _copyStoreUrl = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _this$mod$returnStore3, _this$mod5;
        var root, urlEl, raw, _navigator$clipboard, input, _t2;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              root = document.querySelector('.prepare-store');
              urlEl = root === null || root === void 0 ? void 0 : root.querySelector('[data-storefront-url]');
              raw = ((urlEl === null || urlEl === void 0 ? void 0 : urlEl.getAttribute('href')) || (urlEl === null || urlEl === void 0 ? void 0 : urlEl.textContent) || ((_this$mod$returnStore3 = (_this$mod5 = this.mod).returnStorefrontUrl) === null || _this$mod$returnStore3 === void 0 ? void 0 : _this$mod$returnStore3.call(_this$mod5, this.mod.publicKey)) || '').trim();
              if (raw) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              _context7.p = 1;
              if (!((_navigator$clipboard = navigator.clipboard) !== null && _navigator$clipboard !== void 0 && _navigator$clipboard.writeText)) {
                _context7.n = 3;
                break;
              }
              _context7.n = 2;
              return navigator.clipboard.writeText(raw);
            case 2:
              _context7.n = 4;
              break;
            case 3:
              input = document.createElement('input');
              input.value = raw;
              document.body.appendChild(input);
              input.select();
              document.execCommand('copy');
              input.remove();
            case 4:
              if (typeof siteMessage === 'function') {
                siteMessage('Storefront URL copied', 1500);
              }
              _context7.n = 6;
              break;
            case 5:
              _context7.p = 5;
              _t2 = _context7.v;
              console.warn('Store: copy storefront URL failed', (_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || _t2);
            case 6:
              return _context7.a(2);
          }
        }, _callee7, this, [[1, 5]]);
      }));
      function copyStoreUrl() {
        return _copyStoreUrl.apply(this, arguments);
      }
      return copyStoreUrl;
    }()
  }]);
}();
module.exports = PrepareStoreOverlay;